console.log("IMAGE ENGINE LOADED");

document.addEventListener("DOMContentLoaded", () => {

const uploader =
document.getElementById(
"embroideryImageUpload"
);

const container =
document.getElementById(
"imageLayerContainer"
);

console.log("UPLOADER", uploader);
console.log("CONTAINER", container);

if (!uploader || !container) return;

uploader.addEventListener("change", function(event){

console.log("UPLOAD FIRED");

const file =
  event.target.files[0];

console.log("FILE", file);

if(!file) return;

const reader =
  new FileReader();

reader.onload = function(e){

  console.log("READER LOADED");

  const wrapper =
    document.createElement("div");

  wrapper.className =
    "embroidery-image-layer";
    wrapper.dataset.digitizingFee =
  window.currentDigitizingFee || 0;

wrapper.dataset.colorCount =
  window.currentColorCount || 0;
wrapper.dataset.originalWidth =
150;
wrapper.dataset.complexity =
  window.currentComplexity || "Simple";
    

  wrapper.style.position =
    "absolute";

  wrapper.style.left =
    "100px";

  wrapper.style.top =
    "100px";

  wrapper.style.width =
    "150px";

  const img =
  document.createElement("img");

img.id =
  "embroideryPreviewImage";

img.src =
  e.target.result;

  img.style.width =
    "100%";

  wrapper.appendChild(img);

  const handle =
    document.createElement("div");

  handle.className =
    "resize-handle";

  wrapper.appendChild(handle);

  container.appendChild(wrapper);
  window.lastUploadedEmbroideryLayer =
wrapper;

console.log("IMAGE ADDED", wrapper);

wrapper.addEventListener("click", () => {

  document
    .querySelectorAll(
      ".embroidery-text-layer,.embroidery-image-layer"
    )
    .forEach(el =>
      el.classList.remove("active-layer")
    );

  wrapper.classList.add("active-layer");

  window.selectedEmbroideryLayer =
    wrapper;

});
console.log(
  "IMAGE SRC BEFORE SAVE:",
  img.src
);
window.EMBStorage?.save();


};

reader.readAsDataURL(file);

});

});